module.exports = __webpack_public_path__ + "app-static/img/a3.cd8b5098.png";